export default {"src":"/_next/static/media/sparkle.bd1e640a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};